//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VPopover } from "v-tooltip";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ConsentStatusInfo",
  components: {
    VPopover
  }
});